import * as Library from '../../../../lib/core/library/index';
import { Color } from './color';

export class InteriorColor extends Color {
  public colorSwatch: string;

  /*
   * Constructor()
   */
  constructor();
  constructor(options: object);
  constructor(options?: any) {
    super(options);
    this.colorSwatch = Library.init(options, 'colorSwatch');
  }
}
